<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/awrenD/tc-custom/9780226667393.jpg?1733109847867" alt="This image is the cover for the book Acolytes of Nature"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Acolytes of Nature
      </h1>
      <p class="bookDescription body article font2">
        <p>Although many of the practical and intellectual traditions that make up modern science date back centuries, the category of “science” itself is a relative novelty. In the early eighteenth century, the modern German word that would later mean “science,” <i>naturwissenschaft</i>, was not even included in dictionaries. By 1850, however, the term was in use everywhere. <i>Acolytes of Nature</i> follows the emergence of this important new category within German-speaking Europe, tracing its rise from an insignificant eighteenth-century neologism to a defining rallying cry of modern German culture.<br/><br/> Today’s notion of a unified natural science has been deemed an invention of the mid-nineteenth century. Yet what Denise Phillips reveals here is that the idea of <i>naturwissenschaft</i> acquired a prominent place in German public life several decades earlier. Phillips uncovers the evolving outlines of the category of natural science and examines why Germans of varied social station and intellectual commitments came to find this label useful. An expanding education system, an increasingly vibrant consumer culture and urban social life, the early stages of industrialization, and the emergence of a liberal political movement all fundamentally altered the world in which educated Germans lived, and also reshaped the way they classified knowledge.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Denise Phillips
      </h2>
      
      <p class="authorDescription body article"><B>Denise Phillips</B> is assistant professor of history at the University of Tennessee.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0011d5c6